import { useModalState } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { isAfter } from "date-fns";
import { useMemo } from "react";

interface UseCancelShiftBottomSheetDataParams {
  shiftId: string | undefined;
  shiftStartDate: Date | undefined;
  currentDate: Date;
  clockInStartIso?: string | null | undefined;
  orientationBlockId?: string | null | undefined;
  onShiftCancelled?: () => void;
}

/*
  This hook helps fetch the props needed for the cancel shift bottom sheet.
  Ideally, we would have the cancel shift bottom sheet be its own ModalRoute, but 
  thats too big of a refactor at the moment, so we'll settle for a shared hook among callers.
*/
export function useCancelShiftBottomSheetData(params: UseCancelShiftBottomSheetDataParams) {
  const {
    shiftId,
    shiftStartDate,
    currentDate,
    clockInStartIso,
    orientationBlockId,
    onShiftCancelled,
  } = params;

  const cancelShiftModalState = useModalState();

  const isNoCallNoShow = useMemo(() => {
    if (!isDefined(shiftStartDate)) {
      return false;
    }

    if (isDefined(clockInStartIso)) {
      return false;
    }

    return isAfter(currentDate, shiftStartDate);
  }, [clockInStartIso, currentDate, shiftStartDate]);

  const isOrientationBlockShift = isDefined(orientationBlockId);

  const cancelShiftBottomSheetProps =
    isDefined(shiftStartDate) && isDefined(shiftId)
      ? {
          modalState: cancelShiftModalState,
          isNoCallNoShow,
          shiftStartDate,
          shiftId,
          currentDate,
          isOrientationBlockShift,
          onShiftCancelled,
        }
      : undefined;

  return {
    cancelShiftModalState,
    cancelShiftBottomSheetProps,
    handleOpenCancelShiftBottomSheet: cancelShiftModalState.openModal,
  };
}
